<template>
  <div class="py-3">
    <CardWithCloseButton @onClose="$emit('onClose')">
      <div class="px-5 py-3">
        <div class="flex justify-between items-center">
          <p class="text-sm font-bold text-greenPrimary">Detail Post Order</p>
          <SearchInput id="detailpostorder" @input="search" />
        </div>

        <div
          class="overflow-x-auto relative rounded-lg pt-3"
          v-if="!detailPostOrder.loading"
        >
          <table class="w-full text-sm text-left text-gray-500 mb-3">
            <thead>
              <tr class="bg-gray-200">
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  #
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Feature ID
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Kode Petak
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Jumlah Post Order
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Scene ID
                </th>
                <th
                  scope="row"
                  class="py-3 px-3 text-center border border-gray-300"
                >
                  Order ID
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                class="bg-white text-center"
                v-for="(item, index) in detailPostOrder.rows"
                :key="index"
              >
                <td class="py-3 px-3 border border-gray-300" valign="top">
                  {{ (page - 1) * limit + (index + 1) }}
                </td>
                <td class="py-3 px-3 border border-gray-300" valign="top">
                  {{ item.feature_id }}
                </td>
                <td class="py-3 px-3 border border-gray-300" valign="top">
                  {{ item.kode_petak }}
                </td>
                <td class="py-3 px-3 border border-gray-300" valign="top">
                  {{ item.jumlah_order }}
                </td>
                <td class="py-3 px-3 border border-gray-300 text-left">
                  <ul
                    class="text-sm ml-4"
                    v-for="scene in item.scene_id"
                    :key="scene"
                  >
                    <li id="list">{{ scene }}</li>
                  </ul>
                </td>
                <td class="py-3 px-3 border border-gray-300 text-left">
                  <ul
                    class="text-sm ml-4"
                    v-for="tgl in item.created_date"
                    :key="tgl"
                  >
                    <li id="list">{{ date(tgl) }}</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <PaginationComponent
            v-model:length="length"
            v-model:size="limit"
            v-model:page="page"
            @onSelectChange="changePage"
          />
        </div>

        <LoadingLottie v-if="detailPostOrder.loading" />
        <AlertErrorComponent
          v-if="detailPostOrder.error"
          :message="detailPostOrder.error.response.data.message"
        />
        <div
          class="flex justify-center"
          v-if="detailPostOrder.rows?.length == 0"
        >
          <NoData size="w-full md:w-5/12" />
        </div>
      </div>
    </CardWithCloseButton>
  </div>
</template>
<script>
import AlertErrorComponent from "@/components/AlertErrorComponent.vue";
import CardWithCloseButton from "@/components/CardWithCloseButton.vue";
import LoadingLottie from "@/components/LoadingLottie.vue";
import NoData from "@/components/NoData.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import SearchInput from "@/components/SearchInput.vue";
import { useDashboardStore } from "@/store";
import moment from "moment";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";

export default {
  components: {
    CardWithCloseButton,
    PaginationComponent,
    LoadingLottie,
    AlertErrorComponent,
    NoData,
    SearchInput,
  },
  setup() {
    const dashboardStore = useDashboardStore();
    const { detailPostOrder } = storeToRefs(dashboardStore);

    const limit = ref(25);
    const offset = ref(0);
    const length = ref(0);
    const page = ref(1);
    const q = ref(null);

    const getDetail = async () => {
      await dashboardStore.getDetailPostOrder({});
      length.value = detailPostOrder.value.count;
    };

    onMounted(() => {
      getDetail();
    });

    const changePage = async (value) => {
      page.value = value;
      offset.value = (page.value - 1) * limit.value;
      let dataparams = { offset: offset.value };

      if (q.value != null || q.value != "") {
        dataparams = { ...dataparams, q: q.value };
      }
      await dashboardStore.getDetailPostOrder(dataparams);
      length.value = detailPostOrder.value.count;
    };

    const date = (date) => {
      return moment(date).format("DD-MM-YYYY, HH:mm:ss");
    };

    const search = async (event) => {
      offset.value = 0;
      page.value = 1;
      q.value = event.target.value;

      await dashboardStore.getDetailPostOrder({
        offset: offset.value,
        q: event.target.value,
      });
      length.value = detailPostOrder.value.count;
    };

    return {
      detailPostOrder,
      limit,
      page,
      length,
      changePage,
      date,
      search,
    };
  },
};
</script>
<style>
#list {
  list-style-type: disc;
}
</style>
